import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark, faUser, faXmarkCircle, faBell } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@boozallen-uip/uswds-react-core";
import { UserContext } from "../pages/UserContext";
import { NotificationContext } from "../pages/Notification/NotificationContext";
import { WELCOME_URL, NOTIFICATIONS_URL } from "../utlities/core.constants";
import useLogout from "../hooks/useLogout.hook";

export default function AccountLinks () {
  const [ isDropdownOpen, setIsDropdownOpen ] = useState(false);
  const { user } = useContext(UserContext);
  const { activeCount } = useContext(NotificationContext);
  const { logout } = useLogout();
  const dropdownButtonRef = useRef(null);
  const firstMenuItemRef = useRef(null);

  const handleLogout = () => {
    setIsDropdownOpen(false);
    // logout() clears local state and redirects to Login.gov's RP-Initiated
    // Logout endpoint, which itself redirects back to the Home page on success.
    logout();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdownButton = document.getElementById('dropdown-button');
      const dropdownMenu = document.getElementById('dropdown-menu');

      if (dropdownButton && dropdownMenu &&
          !dropdownButton.contains(event.target) &&
          !dropdownMenu.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape' && isDropdownOpen) {
        setIsDropdownOpen(false);
        dropdownButtonRef.current?.focus();
      }
    };

    window.addEventListener('click', handleClickOutside);
    window.addEventListener('keydown', handleEscape);
    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isDropdownOpen]);

  // Focus first menu item when dropdown opens
  useEffect(() => {
    if (isDropdownOpen && firstMenuItemRef.current) {
      firstMenuItemRef.current.focus();
    }
  }, [isDropdownOpen]);

  const toggleDropdown = useCallback(() => {
    setIsDropdownOpen(prev => !prev);
  }, []);
  return (
    <div className="flex flex-col items-center justify-center overflow-visible">
        <div className={`relative inline-block text-left overflow-visible ${isDropdownOpen ? "bg-primary-darker text-white" : ""}`}>
            <button
              ref={dropdownButtonRef}
              onClick={() => toggleDropdown()}
              type="button"
              id="dropdown-button"
              aria-expanded={isDropdownOpen}
              aria-haspopup="menu"
              aria-controls="dropdown-menu"
              className={`text-sm border-0 inline-flex justify-center w-full px-2 py-2 focus:outline-2 focus:outline-primary ${isDropdownOpen ? "bg-primary-darker text-white" : "bg-white text-primary-darker"}`}
            >
              <FontAwesomeIcon icon={faUser} aria-hidden="true" />
              <span className="ml-1">{user?.email}</span>
            </button>
            <div id="dropdown-menu" className={`origin-top-right absolute right-0 w-full bg-primary-darker z-50 ${isDropdownOpen ? "" : "hidden"}`} role="menu" aria-orientation="vertical" aria-labelledby="dropdown-button">
                <NavLink
                  ref={firstMenuItemRef}
                  to={WELCOME_URL}
                  onClick={() => {setIsDropdownOpen(false)}}
                  className="block px-2 py-2 mb-1 text-white no-underline focus:outline-2 focus:outline-white focus:outline-offset-[-2px]"
                  role="menuitem"
                >
                  <FontAwesomeIcon icon={faBookmark} aria-hidden="true" />
                  <span className="ml-1 text-white">Account Home</span>
                </NavLink>
                <NavLink
                  to={NOTIFICATIONS_URL}
                  onClick={() => {setIsDropdownOpen(false)}}
                  className="block px-2 py-2 mb-1 text-white no-underline focus:outline-2 focus:outline-white focus:outline-offset-[-2px]"
                  role="menuitem"
                >
                  <FontAwesomeIcon icon={faBell} aria-hidden="true" />
                  <span className="ml-1 text-white">
                    Notifications
                    {activeCount > 0 && (
                      <>
                        <span className="ml-2 bg-red text-white text-xs rounded-full px-2 py-0.5" aria-hidden="true">
                          {activeCount > 99 ? '99+' : activeCount}
                        </span>
                        <span className="sr-only">, {activeCount} active</span>
                      </>
                    )}
                  </span>
                </NavLink>
                <Button
                  unstyled
                  onClick={() => handleLogout()}
                  className="no-underline w-full text-left focus:outline-2 focus:outline-white focus:outline-offset-[-2px]"
                  role="menuitem"
                >
                  <span className="block px-2 py-2 mb-1 text-white no-underline">
                    <FontAwesomeIcon icon={faXmarkCircle} aria-hidden="true" />
                    <span className="ml-1">Log Out</span>
                  </span>
                </Button>
            </div>
        </div>
    </div>
  );
}
